import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPropertyList , getInventoryById} from "../services/inventoryService";

export const fetchPropertyList = createAsyncThunk(
    "inventory/fetchPropertyList",
    (requestPayload) => {
      return getPropertyList(requestPayload);
    }
  );

  export const fetchInventoryDetailsById = createAsyncThunk(
    "inventory/fetchPropertyDetailsById",
    (requestPayload) => {
      return getInventoryById(requestPayload);
    }
  );